// Whether a role's or person's capacity says something about how loaded it is. LINQ gives capacity to every role: from
// its people, from the time set on it, or, with neither, the organisation's default (a full-time year for each person).
// Without a default, such a role is given just enough for its work, and an external organisation always is, so their
// load reads 100% whatever the work. The EPM scorecard and workforce report read capacity the same way.
// Pure, so it can be tested without a page
import { FREQUENCY_TYPE, NODE_SUPERTYPE, NODE_TYPE, NodeInsights } from '../common/linqset-base';
import { LinqsetNode } from '../common/linqset-model';

export type CapacitySource = 'people' | 'set' | 'default' | 'none';

export const capacitySource = (node: Pick<LinqsetNode, 'superType' | 'type' | 'properties'>, insights: Pick<NodeInsights, 'hasPeople'> | undefined, defaultHours: number): CapacitySource => {
    if (node.superType !== NODE_SUPERTYPE.ROLE && node.superType !== NODE_SUPERTYPE.PEOPLE) return 'none';
    if (node.type === NODE_TYPE.EXTERNAL_ORGANISATION) return 'none';
    if (node.superType === NODE_SUPERTYPE.ROLE && insights?.hasPeople) return 'people';
    const f = node.properties?.frequency;
    if (f && f.type !== FREQUENCY_TYPE.USE_CALCULATED) return 'set';
    return defaultHours > 0 ? 'default' : 'none';
};

export const capacityIsKnown = (...args: Parameters<typeof capacitySource>) => capacitySource(...args) !== 'none';
